import { render, staticRenderFns } from "./FolderGearDropdown.vue?vue&type=template&id=4dba28b4&scoped=true&"
import script from "./FolderGearDropdown.vue?vue&type=script&lang=ts&"
export * from "./FolderGearDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dba28b4",
  null
  
)

export default component.exports